<script>
	import { hero_expanded } from './../stores.js'
  import Logo from "./Logo.svelte";
  import HeaderNav from "./HeaderNav.svelte"
</script>

<header class:expanded={$hero_expanded}>
  <Logo on:click={() => $hero_expanded = true}/>
  <HeaderNav />
</header>

<style>
  header {
    z-index: 3;
    -webkit-app-region: drag;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 2rem 6rem;
    transition: padding var(--transition-props);
  }

  header.expanded {
    padding: 4rem 6rem;
  }

  @media only screen and (max-width: 1024px) {
    header.expanded {
      padding: 2rem 4rem;
    }
    header {
      padding-left: 2rem;
    }
  }
</style>